<script setup lang="ts">
import type { ComputedRef } from "vue";
import { SelectRoot, type SelectRootProps, type SelectRootEmits, useForwardPropsEmits } from "reka-ui";

const props = withDefaults(defineProps<SelectRootProps>(), {});
const emits = defineEmits<SelectRootEmits>();
// Only the set props and the emits as handlers; typed as such (see HPixSelectArrow).
const forwarded = useForwardPropsEmits(props, emits) as ComputedRef<SelectRootProps>;
</script>

<template>
  <SelectRoot v-bind="forwarded">
    <slot />
  </SelectRoot>
</template>
